import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-primary-900 text-background-100">
      <div className="mx-auto max-w-shell px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-background-50">
                <i className="ri-movie-2-line text-lg" />
              </span>
              <span className="font-heading text-lg font-extrabold tracking-tight text-background-50">
                日韩伦理片
              </span>
            </div>
            <p className="mt-4 max-w-sm text-[13px] leading-relaxed text-primary-100/80">
              一个以资料与解析为核心的日韩伦理影视内容站。我们不追逐猎奇，只整理作品、人物与议题，让读者在阅读中找到自己的判断。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["日本", "韩国", "电影", "电视剧", "短片"].map((tag) => (
                <span key={tag} className="rounded-full border border-background-50/20 px-2.5 py-1 font-label text-[11px] text-primary-100/80">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-label text-[11px] uppercase tracking-[0.2em] text-primary-300">内容分类</h3>
            <ul className="mt-4 space-y-2.5 text-[13px]">
              {["电影", "电视剧", "短片"].map((key) => (
                <li key={key}>
                  <Link to={`/category/${encodeURIComponent(key)}`} className="text-background-100/85 transition-colors hover:text-accent-300">
                    {key}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/search" className="text-background-100/85 transition-colors hover:text-accent-300">
                  站内搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-label text-[11px] uppercase tracking-[0.2em] text-primary-300">站内导航</h3>
            <ul className="mt-4 space-y-2.5 text-[13px]">
              <li>
                <Link to="/" className="text-background-100/85 transition-colors hover:text-accent-300">首页</Link>
              </li>
              <li>
                <Link to="/specials" className="text-background-100/85 transition-colors hover:text-accent-300">专题合集</Link>
              </li>
              <li>
                <Link to="/about" className="text-background-100/85 transition-colors hover:text-accent-300">关于我们</Link>
              </li>
              <li>
                <Link to="/about#feedback" className="text-background-100/85 transition-colors hover:text-accent-300">内容反馈</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-label text-[11px] uppercase tracking-[0.2em] text-primary-300">编辑说明</h3>
            <p className="mt-4 text-[13px] leading-relaxed text-primary-100/80">
              本站作品条目、评分与解析均为编辑整理与演示数据，收藏与分享功能在浏览器本地完成，不涉及任何账号与付费服务。
            </p>
            <p className="mt-3 text-[12px] leading-relaxed text-primary-100/60">
              仅面向成年读者，内容涉及作品情节讨论，不含任何影像素材。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-[12px] text-primary-100/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 日韩伦理片 · 影视资料演示站</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <Link to="/about" className="transition-colors hover:text-background-50">版权声明</Link>
            <Link to="/about" className="transition-colors hover:text-background-50">服务条款</Link>
            <span className="font-label tracking-wider">Made for readers, not for clicks.</span>
          </p>
        </div>
      </div>
    </footer>
  );
}